import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const fetchViolationsOrder = createAsyncThunk(
  'violations/fetchViolationsOrder',
  async (transaction_key, thunkAPI) => {
    try {
      const res = await axiosInstance.get(`/admin/orders/${transaction_key}/violations`);

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deleteViolationOrderById = createAsyncThunk(
  'violations/deleteViolationOrderById',
  async (id, thunkAPI) => {
    try {
      const res = await axiosInstance.delete(`/violations/${id}`);

      return res.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
